// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'money-atm';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M13.973 14.813H4.027a.563.563 0 0 1-.555-.646l1.59-10.604h7.875l1.59 10.604a.56.56 0 0 1-.556.646zM3.375 17.438h11.25' />
    <path d='M10.125 6.938h-1.5A1.005 1.005 0 0 0 8.25 8.88l1.545.615a1.005 1.005 0 0 1-.375 1.943h-1.5M9 6.938V5.813m0 6.75v-1.126M2.063 6.188h-.938a.57.57 0 0 1-.563-.563v-4.5a.57.57 0 0 1 .563-.563h15.75a.57.57 0 0 1 .563.563v4.5a.57.57 0 0 1-.563.563h-.938' />
  </g>
);

export const viewBox = '0 0 18 18';
